// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewDiagnosisResponse } from './rapid-review-diagnosis-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewReasonForVisitResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewReasonForVisitResponse extends GandalfModelBase {

	@GandalfArray(RapidReviewDiagnosisResponse)
	historyDiagnoses!: RapidReviewDiagnosisResponse[];

	@GandalfProperty({ designType: Boolean })
	isMedicalReason!: boolean;

	@GandalfProperty({ designType: String })
	patientReason!: string | null;

	@GandalfProperty({ designType: String })
	providerReason!: string | null;

	@GandalfProperty({ designType: Number })
	reasonForVisitId!: number;

}
